// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.9/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".main-content[data-v-61fcfdf8]{position:relative;width:1710px}.main-content .inner-content[data-v-61fcfdf8]{overflow:auto}.main-content .blank-box[data-v-61fcfdf8]{height:100px}.text-body[data-v-61fcfdf8]{min-height:300px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
